// Link di rimando verso marketing.ucamp.it (UCAMP-87 plan 9). L'indirizzo viene
// da VUE_APP_MARKETING_URL (.env.<mode>), con la produzione come default.
// Il marketing non ha accesso automatico: la prima volta si fa login con le
// stesse credenziali (superadmin, plan 8).
export const MARKETING_URL = (process.env.VUE_APP_MARKETING_URL || 'https://marketing.ucamp.it').replace(/\/$/, '')

export const marketingCenterUrl = (centerId) => `${MARKETING_URL}/centers?ucamp_center_id=${encodeURIComponent(centerId)}`

export const marketingAppUserUrl = (email) => `${MARKETING_URL}/app-users?q=${encodeURIComponent(email || '')}`

export const marketingPushUrl = () => `${MARKETING_URL}/push`
